<!--
 * @Descripttion: 
 * @version: 
 * @Author: guantingting
 * @Date: 2019-07-24 14:13:42
 * @LastEditors: guantingting
 -->
<template lang="html">
  <div class="home-yuesao">
    <h3>
      <span class="home-yuesao-text">{{ config.title }}</span>
      <a
        class="show-more"
        :href="`/v/workers/1?citycode=${this.citycode}&category=${this.category}`"
        @click="trackClick(200010, '月嫂查看更多')"
      >
        <span class="home-yuesao-more">查看更多</span><span class="icon"></span>
      </a>
    </h3>
    <div class="home-yuesao-worker">
      <yuesao :list="list" />
    </div>
    <ul
      class="home-yuesao-activity"
      v-if="config.activity && config.activity.length > 0"
    >
      <li v-for="(item, index) in config.activity">
        <a :href="item.link">
          <img :src="$$viewImage(item.image)" />
          <div class="home-yuesao-activity-content">
            <p class="home-yuesao-activity-title">{{ item.title }}</p>
            <p class="home-yuesao-activity-text">{{ item.text }}</p>
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import yuesao from './yuesao'

export default {
  PAGE_ID: '288987',
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    },
    config: {
      type: Object,
      default() {
        return {}
      }
    },
    citycode: {
      type: [String, Number],
      default: '320100'
    },
    category: {
      type: String,
      default: '10111019'
    }
  },
  methods: {},
  components: {
    yuesao
  }
}
</script>

<style lang="scss">
@import '../../assets/css/mixin';
.home-yuesao {
  margin-bottom: rem(30px);
  .show-more {
    display: flex;
    align-items: center;
    .icon {
      display: inline-block;
      height: rem(18px);
      width: rem(10px);
      margin: 0 0 rem(2px) rem(10px);
      background: url('//cmspic-10004025.image.myqcloud.com/a887b720-0205-11ea-98a0-c91677e5da3e_size_9x18')
        no-repeat center center;
      background-size: rem(8px) auto;
    }
  }
  h3 {
    padding: rem(30px) rem(20px) rem(28px) rem(20px);
    display: flex;
    align-items: center;

    .home-yuesao-text {
      flex: 1;
      font-size: rem(36px);
      font-weight: 600;
      color: #000;
    }
    a {
    }
    .home-yuesao-more {
      font-size: rem(24px);
      color: #666666;
    }
    .iconfont {
      display: inline-block;
      color: #666;
      font-size: rem(24px);
      transform: rotate(-90deg);
    }
  }

  .home-yuesao-activity {
    padding: rem(40px) rem(20px) 0 rem(20px);

    li {
      padding-bottom: rem(30px);
    }
    a {
      display: flex;
    }
    img {
      width: rem(250px);
      height: rem(150px);
      object-fit: cover;
    }
    .home-yuesao-activity-content {
      flex: 1;
      padding-left: rem(20px);
    }
    .home-yuesao-activity-title {
      font-size: rem(30px);
      color: #121212;
      font-weight: 700;
    }
    .home-yuesao-activity-text {
      padding-top: rem(21px);
      font-size: rem(24px);
      color: #999999;
    }
  }
}
</style>
